import { Component, Input, ViewContainerRef } from '@angular/core';

import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentService } from '../../../services/document.service';
import { MapCoreDocument } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'mc-doc-source-item-ng',
  templateUrl: './doc-source-item.component.html',
  styleUrls: ['./doc-source-item.component.scss']
})
export class DocSourceItemComponent extends BaseComponent {

  private _document: MapCoreDocument;
  get document() {
    return this._document;
  }
  @Input()
  set document(value) {
    this._document = value;
  }

  private _currentFeature: { [key: string]: any };
  get currentFeature() {
    return this._currentFeature;
  }
  @Input()
  @InputConverter(JSONConverter)
  set currentFeature(value) {
    this._currentFeature = JSONConverter(value);
  }

  @Input()
  currentDocument: MapCoreDocument;

  get showHideClass(): string {
    if (this.currentDocument) {
        return this.document !== this.currentDocument ? 'hide' : 'show';
    }
    return ''; // if currentDocSource is not populated yet, don't return a class.
  }

  get isTypeSupported(): boolean {
      return this.isImage || this.isVideo;
  }

  get isImage(): boolean {
      return this.documentService.isImage(this.document);
  }

  get isVideo(): boolean {
      return this.documentService.isVideo(this.document);
  }

  constructor(_vcr: ViewContainerRef, private readonly documentService: DocumentService) {
    super(_vcr);
  }
}
